(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* === Header helpers: announcement offset + logo swap === */
  (() => {
    const root = document.documentElement;
    
    // Immediately mark that JavaScript has loaded to enable proper CSS logic
    root.classList.add('js-loaded');

    function setAnnouncementHeight() {
      // The section wrapper uses this class per your schema
      const barSection = document.querySelector('.announcement-bar-section');
      // Prefer the inner bar if present (it has the padding)
      const bar = barSection?.querySelector('.announcement-bar') || barSection;
      const h = bar ? bar.offsetHeight : 0;
      root.style.setProperty('--announcement-height', `${h}px`);
    }

    // Keep the variable fresh
    window.addEventListener('load', setAnnouncementHeight, { once: true });
    window.addEventListener('resize', setAnnouncementHeight);
    // React to any dynamic content changes (sliders, text swaps)
    const barSection = document.querySelector('.announcement-bar-section');
    if (barSection && 'ResizeObserver' in window) {
      const ro = new ResizeObserver(setAnnouncementHeight);
      ro.observe(barSection);
    }

    // Enhanced logo and header state management
    function updateHeaderState() {
      const currentScroll = window.scrollY || document.documentElement.scrollTop;
      const isHomePage = document.body.classList.contains('template-index');
      const header = document.querySelector('.section-header');
      
      // Different scroll thresholds for home vs non-home pages
      const scrollThreshold = isHomePage ? 100 : 10; // 100px for home, 10px for others
      const scrolled = currentScroll > scrollThreshold;
      
      // Add/remove scrolled class for header background and logo switching
      const wasScrolled = root.classList.contains('page-scrolled');
      root.classList.toggle('page-scrolled', scrolled);
      
      // Add slide-down animation when transitioning to scrolled state on home page
      if (scrolled && !wasScrolled && isHomePage && header) {
        header.classList.add('slide-down-animation');
        // Remove animation class after animation completes
        setTimeout(() => {
          header.classList.remove('slide-down-animation');
        }, 300);
      }
    }

    // Initialize on page load - detect current scroll position
    function initializeHeaderState() {
      const root = document.documentElement;
      const header = document.querySelector('.section-header');
      const currentScroll = window.scrollY || document.documentElement.scrollTop;
      const isHomePage = document.body.classList.contains('template-index');
      
      // Different scroll thresholds for home vs non-home pages
      const scrollThreshold = isHomePage ? 100 : 10; // 100px for home, 10px for others
      
      // Always start clean - remove any classes first
      root.classList.remove('page-scrolled');
      if (header) {
        header.classList.remove('shopify-section-header-sticky', 'scrolled-past-header', 'slide-down-animation');
      }
      
      // Handle different page types
      if (currentScroll > scrollThreshold) {
        root.classList.add('page-scrolled');
        if (header) {
          header.classList.add('shopify-section-header-sticky');
          // Add slide-down animation only for non-home pages on load
          if (!isHomePage) {
            header.classList.add('slide-down-animation');
          }
        }
      } else if (!isHomePage) {
        // Non-home pages get secondary logo even at top, but no animation on initial load
        // This is handled by CSS with js-loaded class
      }
    }

    // Throttled scroll handler for better performance
    let ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateHeaderState();
          ticking = false;
        });
        ticking = true;
      }
    }

    // Initialize immediately and on page events
    initializeHeaderState();
    window.addEventListener('load', initializeHeaderState, { once: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    
    // Handle page navigation (for SPA-like behavior)
    window.addEventListener('pageshow', initializeHeaderState);
    
    // Also ensure body has correct page type class (Shopify should handle this but let's be sure)
    document.addEventListener('DOMContentLoaded', () => {
      const isHomePage = window.location.pathname === '/' || 
                         window.location.pathname === '' ||
                         document.querySelector('body[class*="index"]') !== null;
      
      if (isHomePage && !document.body.classList.contains('template-index')) {
        document.body.classList.add('template-index');
      }
    });
  })();


  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Only add sticky class if we're always sticky AND not at the top
      if (this.headerIsAlwaysSticky) {
        const currentScroll = window.scrollY || document.documentElement.scrollTop;
        const isHomePage = document.body.classList.contains('template-index');
        const scrollThreshold = isHomePage ? 100 : 10; // 100px for home, 10px for others
        
        if (currentScroll > scrollThreshold) {
          this.header.classList.add('shopify-section-header-sticky');
        }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.ticking = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.updateHeaderOnScroll();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    updateHeaderOnScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      // Trigger the slide down animation by ensuring page-scrolled class is present
      document.documentElement.classList.add('page-scrolled');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      // Also remove the page-scrolled class when resetting to ensure no sticky spacing
      document.documentElement.classList.remove('page-scrolled');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
